import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { ITransactionFeature } from './transaction.feature.state';
import { TransactionState } from './transaction.state';

export const getTransactionState: MemoizedSelector<ITransactionFeature, TransactionState> = createFeatureSelector<TransactionState>(
  nameof<ITransactionFeature>('transactionFeature')
);

export const getIsLoading = createSelector(getTransactionState, (state: TransactionState) => state.isLoading);
export const getFailures = createSelector(getTransactionState, (state: TransactionState) => state.failures);
export const getProducts = createSelector(getTransactionState, (state: TransactionState) => state.products);
export const getTransacitonFlowType = createSelector(getTransactionState, (state: TransactionState) => state.transactionFlowType);
export const getWordOfTheDay = createSelector(getTransactionState, (state: TransactionState) => state.wordOfTheDay);
export const getTransactionId = createSelector(getTransactionState, (state: TransactionState) => state.transactionId);
export const getTransactionReceipt = createSelector(getTransactionState, (state: TransactionState) => state.transactionReceipt);
